interface CloseIconProps {
  className?: string;
  onClick?: () => void;
}

export function CloseIcon({ className = "h-3 w-3", onClick }: CloseIconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      onClick={onClick}
    >
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}
